export default __webpack_public_path__ + "static/media/embedly.daebbd3a.svg";